import { useThemeData } from "../context/ThemeContext";

export const useCustomTheme = () => {
  const { themeConfig, mode, toggleColorMode } = useThemeData();

  // Wraps the raw toggleColorMode so callers can pass an event OR nothing
  const toggleWithAnimation = (eventOrOrigin) => {
    let x, y;

    if (eventOrOrigin?.currentTarget) {
      // Called with a React SyntheticEvent (e.g. onClick={toggleColorMode})
      const rect = eventOrOrigin.currentTarget.getBoundingClientRect();
      x = rect.left + rect.width / 2;
      y = rect.top + rect.height / 2;
    } else if (eventOrOrigin?.x !== undefined) {
      // Called with a plain { x, y } origin object
      x = eventOrOrigin.x;
      y = eventOrOrigin.y;
    } else {
      // No origin — fallback to screen center
      x = window.innerWidth / 2;
      y = window.innerHeight / 2;
    }

    toggleColorMode(x, y);
  };

  return {
    config: themeConfig,
    mode,
    toggleColorMode: toggleWithAnimation, // ← wrapped version
    isDark: mode === "dark",
    isLight: mode === "light",
    getColor: (colorKey) => themeConfig[colorKey] || themeConfig.primary,
    getGradient: (type = "primary") =>
      themeConfig[`gradient_${type}`] || themeConfig.gradient_primary,
    getSpacing: (multiplier = 1) => themeConfig.spacing_unit * multiplier,
  };
};
